<template>
  <v-card
    class="mx-auto"
    max-width="600"
    v-role="'func'"
  >
  <div align="center">

  <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title><h2> Solicitações de Transferência</h2>
            </v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
</div>

    <v-list>
      <v-list-item-group v-model="model">
        <v-list-item
          v-for="(item, i) in solicitacao"
          :key="i"
          :disabled="item.disabled"
        >
          <v-list-item-content >
            <v-list-item-title
              v-text="item.descricao"
               @click="Mostrar()"
              ></v-list-item-title>
             <v-list-item-subtitle  >
            <strong>{{item.quantidade}}</strong>
                                Transferências Pendente
                              </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  data: () => ({
    pendentes: [],
    solicitacao: [],
    items: [
      {
        quantidade: 0,
        descricao: '',
        idInstituicao: 0
      }

    ],
    model: 0
  }),
  created () {
    this.initializeSolicitacao()
    this.initializeTransferenciaPendente()
  },
  computed: {

  },

  methods: {
    async Mostrar () {
      return this.$router.push('/AlunosPendentes')
    },
    async  initializeSolicitacao () {
      try {
        this.solicitacao = await axios
          .get('/countSolicitacoesDeTranferencia')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  initializeTransferenciaPendente () {
      try {
        this.pendentes = await axios
          .get('/TransferenciaPendente')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
  }
}
</script>
